import { graphql } from "~/gql";

export const FEE_EARNERS_LEVEL_QUERY = graphql(/* GraphQL */ `
  query FindFeeEarnerByLevels {
    feeEarnerLevels {
      records {
        id
        description
        externalReference
      }
    }
  }
`);
